<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-img :src="require('@/assets/img/logo.png')" class="mb-10" height="90" contain />

        <v-card class="elevation-12">
          <v-card-text class="pa-0">
            <v-tabs v-model="tab" fixed-tabs background-color="transparent" color="primary">
              <v-tab>{{ $t("auth.login_email") }}</v-tab>
              <v-tab>{{ $t("auth.login_mobile") }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item class="pa-4">
                <v-form data-vv-scope="emailform">
                  <v-text-field
                    :name="`email_${Date.now() + Math.random()}`"
                    v-model="email"
                    prepend-icon="person"
                    :label="$t('auth.email')"
                    class="required-field"
                    v-validate="'required'"
                    :error-messages="errors.collect('emailform.email')"
                    data-vv-name="emailform.email"
                    type="text"
                    @keydown="checkKeyPress"
                    placeholder=" "
                  ></v-text-field>
                  <v-text-field
                    :name="`password_${Date.now() + Math.random()}`"
                    v-model="password"
                    prepend-icon="lock"
                    :label="$t('auth.password')"
                    class="required-field"
                    v-validate="'required'"
                    :error-messages="errors.collect('emailform.password')"
                    data-vv-name="emailform.password"
                    type="password"
                    @keydown="checkKeyPress"
                    persistent-hint
                    placeholder=" "
                  ></v-text-field>

                  <router-link :to="'/auth/' + locale + '/forgot'" class="text-center d-block mt-5">
                    {{ $t("auth.forgot.forgot") }}
                  </router-link>
                </v-form>
              </v-tab-item>
              <v-tab-item class="pa-4">
                <v-form data-vv-scope="mobileform">
                  <v-text-field
                    v-model="mobile"
                    prepend-icon="phone"
                    :label="$t('auth.mobile')"
                    class="required-field"
                    v-validate="'required'"
                    :error-messages="errors.collect('mobileform.mobile')"
                    data-vv-name="mobileform.mobile"
                    type="text"
                    @keydown="checkKeyPress"
                  ></v-text-field>
                </v-form>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <v-card-actions class="pa-0">
            <action-button
              type="default"
              @click="login"
              :text="this.$t('auth.login')"
              color="primary"
              class="login-btn primary ma-0"
              :icon_only_xs="false"
            />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showEnterSMSCode" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-app-bar dark color="primary">
          {{ $t("auth.sms_code") }}
        </v-app-bar>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <p>{{ $t("auth.enter_code_sms", { mobile: this.mobile }) }}</p>
          <v-flex xs12>
            <v-text-field name="sms_code" v-model="sms_code" :label="$t('auth.enter_code')" autocomplete="new-password"></v-text-field>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <action-button type="cancel" @click="closeSMSCodeDialog()" />
          <action-button type="validate" @click="validateSMSCode" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "login",

  props: ["locale"],

  data() {
    return {
      email: "",
      password: "",
      mobile: "",
      tab: 0,

      showEnterSMSCode: false,
      sms_code: null,
      sms_uuid: null,

      dictionary: {
        attributes: {
          "emailform.email": this.$t("auth.email"),
          "emailform.password": this.$t("auth.password"),
          "mobileform.mobile": this.$t("auth.mobile")
        }
      }
    }
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  created() {
    let vm = this
    let user = localStorage.getItem("__crrntUser")

    this.$updateSetting("fe_locale", this.computedLocale)
    this.$i18n.locale = this.computedLocale

    if (user) {
      vm.$router.push(this.BACKEND_URL + "/dashboard")
    }
  },

  computed: {
    computedLocale() {
      return this.locale
    }
  },

  methods: {
    login() {
      let vm = this

      if (this.tab == 0) {
        // Email
        this.$validator
          .validateAll("emailform")
          .then((valid) => {
            if (valid) {
              axios
                .post(this.API_URL + "auth/login", {
                  email: vm.email,
                  password: vm.password
                })
                .then((res) => {
                  this.postLogin(res.data)
                })
                .catch((err) => console.log(err))
            }
          })
          .catch(() => {})
      } else {
        // Mobile
        this.$validator
          .validateAll("mobileform")
          .then((valid) => {
            if (valid) {
              this.openSMSCodeDialog()
            }
          })
          .catch(() => {})
      }
    },
    mobileLogin(id, token) {
      axios
        .post(this.API_URL + "auth/loginUser", {
          id: id,
          token: token
        })
        .then((res) => {
          this.postLogin(res.data)
        })
        .catch((err) => console.log(err))
    },
    postLogin(data) {
      let vm = this
      let token = data.access_token
      let user = data.user_data

      if (token && user && user.status == 1) {
        let forcechangepassword = user.force_change_password
        let status = user.status
        let locale = "no"

        this.$cookies.set(`${this.COOKIE_PREFIX}access_token`, token)
        vm.$setAuthorization(token)
        vm.$init(token, user)

        let localesetting = user.settings.find((i) => i.key == "locale")
        if (localesetting && localesetting.value) {
          locale = localesetting.value
        }

        this.$updateSetting("fe_locale", locale)
        this.$updateSetting("locale", locale)
        this.$i18n.locale = locale

        if (status == 1 && !forcechangepassword) {
          this.$router.push(this.BACKEND_URL + "/dashboard")
          this.$store.dispatch("notification/showPopupNotifications", vm)
        } else if (status == 1 && forcechangepassword) {
          this.$router.push("/auth/" + locale + "/forcechangepassword")
        } else {
          vm.$awn.alert(vm.$t("auth.login_error"))
        }
      } else {
        vm.$awn.alert(vm.$t("auth.login_error"))
      }
    },
    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.login()
      }
    },
    openSMSCodeDialog() {
      axios
        .post(this.API_URL + "smsotp/generate", {
          type: "login-mobile",
          number: this.mobile
        })
        .then((res) => {
          let status = res.data.status

          if (status == "ok") {
            this.showEnterSMSCode = true
            this.sms_uuid = res.data.uuid
          } else {
            let message = res.data.message || this.$t("auth.sms_otp_send_failed")
            this.$awn.alert(message)
          }
        })
        .catch((err) => console.log(err))
    },
    validateSMSCode() {
      axios
        .post(this.API_URL + "smsotp/validate", {
          type: "login-mobile",
          uuid: this.sms_uuid,
          code: this.sms_code
        })
        .then((res) => {
          let status = res.data.status
          let type = res.data.type

          if (status == "ok") {
            this.closeSMSCodeDialog()

            console.log(type)

            if (type == "login-mobile") {
              var userid = res.data.param_userid
              var usertoken = res.data.param_usertoken
              this.mobileLogin(userid, usertoken)
            }
          } else {
            let message = res.data.message || this.$t("auth.sms_otp_incorrect_code")
            this.$awn.alert(message)
          }
        })
        .catch((err) => console.log(err))
    },
    closeSMSCodeDialog() {
      this.showEnterSMSCode = false
      this.sms_code = null
      this.sms_uuid = null
    }
  }
}
</script>